import Reports from '@/reports/orders/Statistics'
import ReportPrintPreview from '@/reports/orders/StatisticsPrintPreview'
import { i18n } from '@/plugins/i18n'

let routes = [
    {
        path: '/reports',
        name: 'reports',
        component: Reports,
        meta: {
            title: i18n.tc('reports.report', 2),
            requiresAuth: true,
            authorize: ['ADMIN']
        }
    },
    {
        path: '/reports/preview',
        name: 'report-preview',
        component: ReportPrintPreview,
        meta: {
            title: i18n.tc('general.preview'),
            requiresAuth: true,
            authorize: ['ADMIN']
        }
    }
]
export default routes
